export class EmployeeUnitRequest{
    unitId: number;
    screen?: string;
    
    constructor(  unitId: number, screen?: string){
        this.unitId = unitId;
        this.screen = screen
    }
}